import React, { useEffect, useRef } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { Button } from '@mui/material';
dayjs.extend(advancedFormat);

const CertificateDownloader = ({
  name,
  courseName,
  date,
  templateSrc = '/assets/certificate-template.png',
}) => {
  const certRef = useRef();
  const dateObj = dayjs(date);

  useEffect(() => {
    // download certificate on load
    handleDownload();
  }, [dateObj]);

  const handleDownload = async () => {
    const canvas = await html2canvas(certRef.current, {
      scale: 1.5, // Lower scale = smaller image
    });

    const imgData = canvas.toDataURL('image/png');

    // A5 size: 210 × 148 mm → landscape: 148 × 210
    const pdf = new jsPDF('landscape', 'mm', 'a5');
    pdf.addImage(imgData, 'PNG', 0, 0, 210, 148); // full width A5 landscape
    pdf.save(`${name}_certificate.pdf`);
  };

  return (
    <>
      {/* Hidden cert */}
      <div
        ref={certRef}
        style={{
          position: 'absolute',
          top: '-9999px',
          left: '-9999px',
          width: '842px', // Smaller canvas (A5 @ 96dpi)
          height: '595px',
          fontFamily: "'Emblema One', cursive",
        }}
      >
        <img
          src={templateSrc}
          alt="Certificate"
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1,
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: '39%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '18px',
            color: '#000',
            zIndex: 2,
            textAlign: 'center',
            width: '100%',
          }}
        >
          {name}
        </div>

        <div
          style={{
            position: 'absolute',
            top: '57.5%',
            left: '51%',
            transform: 'translate(-50%, -50%)',
            fontSize: '18px',
            color: '#000',
            zIndex: 2,
            textAlign: 'center',
            width: '100%',
          }}
        >
          <strong>{courseName}</strong>
        </div>

        <div
          style={{
            position: 'absolute',
            top: '68.4%',
            left: '50.5%',
            transform: 'translate(-50%, -50%)',
            fontSize: '16px',
            color: '#000',
            zIndex: 2,
          }}
        >
          {dayjs().format('DD-MMM-YYYY')}
        </div>
      </div>

      {/* Download Button */}
      <div style={{ textAlign: 'center' }}>
        <Button
          variant="contained"
          size="medium"
          sx={{
            borderRadius: 50,
            background: 'rgb(47, 104, 128',
            fontSize: '16px',
            border: '1px solid rgb(47, 104, 128)',
            width: '100%',
          }}
          onClick={handleDownload}
        >
          Download Certificate
        </Button>
      </div>
    </>
  );
};
export default CertificateDownloader;
